export function getHasListingBoardCardHead({ actions, archived, onSelect }) {
  return Boolean(onSelect) || Boolean(archived) || actions.length > 0
}
